<template>
  <div class="language-switcher" :style="color ? { color: color } : {}">
    <select
      class="language-switcher-select"
      :value="$i18n.locale"
      aria-label="Language / Langue"
      @change="onChange"
    >
      <option v-for="l in languages" :key="l.code" :value="l.code">{{ l.label }}</option>
    </select>
  </div>
</template>

<script>
import { setLocale } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  props: {
    color: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      languages: [
        { code: 'en', label: 'English' },
        { code: 'fr', label: 'Français' },
        { code: 'es', label: 'Español' },
        { code: 'sv', label: 'Svenska' },
        { code: 'el', label: 'Ελληνικά' },
        { code: 'da', label: 'Dansk' }
      ]
    }
  },
  methods: {
    onChange(event) {
      setLocale(event.target.value, { persist: true })
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}
.language-switcher-select {
  background: transparent;
  color: inherit;
  border: 1px solid rgba(125, 125, 125, 0.5);
  border-radius: 0.25rem;
  padding: 0.15rem 0.4rem;
  font-size: 0.8rem;
  cursor: pointer;
}
.language-switcher-select option {
  color: initial;
}
</style>
